import React from 'react';
import useStatsigHelper from '../../../utils/useStatsigHelper';
import { ComponentMap, ReactLazyComponent } from '../../Contentful/ComponentMap';

const ContentfulStatsig = (props) => {
  const componentProps = useStatsigHelper(props);

  const Component = ComponentMap[componentProps.__typename];

  return (
    <ReactLazyComponent>
      <Component {...componentProps} />
    </ReactLazyComponent>
  );
};
export default ContentfulStatsig;
